import * as types from './types'

export default {
  [types.COMPETENCES_SEARCH_RESULT]: state => state.competencesSearchResult,
  [types.CLOSING_EXCEPTIONS_SEARCH_RESULT]: state => state.closingExceptionsSearchResult,
  [types.CURRENT_COMPETENCE]: state => state.currentCompetence,
  [types.CLOSING_EXCEPTION_CATEGORIES]: state => state.closingExceptionCategories,
}
